const list=[
  {
    title:"用户付费模式",
    secondTitle:'自运营模式合作案例',
    img:'image/wireless/b1.png',
    jumpId:[36,38],
    desc:"网联云认证计费系统支持灵活多样的计费运营模式，校园网网络套餐类型多样，用户可根据需" +
      "求进行自由搭配购买，能够同时满足合作方和用户个性化需求，大幅提升校园无线网络用户转" +
      "化率。",
    point:[
      {
        title:"部署简单",
        desc:"：云认证计费系统云端部署，即开即用，专为场景营销运营而生"
      },
      {
        title:"计费灵活",
        desc:"：网络时长、速率、时长、终端数在业务套餐内可自由搭配"
      },{
        title:"支付便捷",
        desc:"：校园网用户在线付费，即付即用，自动续费"
      }
    ]
  },
  {
    title:"融合套餐模式",
    secondTitle:'融合套餐模式合作案例',
    img:'image/wireless/businessRh.png',
    jumpId:[35,39],
    desc:"对于运营商在校园内发售号卡、宽带业务的场景，通过网联创新的业务运营模式，将运营商校园" +
      "号卡业务与校园无线业务结合，帮助运营商提高校园号卡与宽带业务的开通率。",
    point:[
      {
        title:"接入多运营商",
        desc:"：满足同时接入多运营商场景，吸引更多用户办理业务套餐"
      },
      {
        title:"多业务融合",
        desc:"：将运营商号卡与校园无线业务融合，使运营商校园号卡、宽带发售率倍增"
      },{
        title:"运营便捷",
        desc:"：对接运营商开户系统，号卡发售后自动开通用户校园网账户，无需人工二次开通"
      }
    ]
  },
  {
    title:"更多创新运营模式",
    secondTitle:'更多创新运营模式合作案例',
    img:'image/wireless/businessMore.png',
    jumpId:[43,37],
    desc:"",
    point:[
      {
        title:"按房间付费模式：",
        desc:"按房间付费模式是网联根据用户实际需求推出的创新型定制化运营模式，用户按房间为单位进行订购，支持一键订购，全屋使用，房间内所有用户费用平均分担，性价比更高、更划算。"
      },
      {
        title:"校方收费模式：",
        desc:"校方收费模式是指学校对校园网网络费用进行统一收费，类似水/电费、住宿费一样直接在杂" +
          "费中进行收取，校园网网络费用福利性定价，相比于用户单独付费套餐费用更加实惠，用户" +
          "转换率能够达到百分之百。"
      }
    ]
  }
]
export  default  list



// WEBPACK FOOTER //
// ./src/pages/wireless/business.js